import { JSONSchema7Type } from 'json-schema';
import ControlState from '../controlState';
import JSONSchema7Properties from '../jSONSchema7Properties';

export default (control: ControlState, property: string): JSONSchema7Type => {
  return (control.schema?.properties as JSONSchema7Properties)[property]
    ?.default as JSONSchema7Type;
};
